import { render, staticRenderFns } from "./offlineTraining.vue?vue&type=template&id=32c4e7ce&scoped=true&"
import script from "./offlineTraining.vue?vue&type=script&lang=js&"
export * from "./offlineTraining.vue?vue&type=script&lang=js&"
import style0 from "./offlineTraining.vue?vue&type=style&index=0&id=32c4e7ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c4e7ce",
  null
  
)

export default component.exports